import { Box, Card, CardContent, CardHeader, Chip, Divider, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function UserCard({ user }) {
    const { t } = useTranslation()
    return (
        <Card>
            <CardHeader title={t("User's Info")} />
            <Divider />
            <CardContent>
                <Box my={20} display="flex" justifyContent="space-between" alignItems="center">
                    <Typography sx={{ fontWeight: "bold" }}>{t("Full Name")}</Typography>
                    <Chip size="small" label={`${user?.firstName} ${user?.lastName}`} variant="outlined" color="primary" />
                </Box>
                <Box my={20} display="flex" justifyContent="space-between" alignItems="center">
                    <Typography sx={{ fontWeight: "bold" }}>{t("Phone")}</Typography>
                    <bdi>
                        <Chip size="small" label={user?.phone} variant="outlined" color="primary" />
                    </bdi>
                </Box>
                <Box my={20} display="flex" justifyContent="space-between" alignItems="center">
                    <Typography sx={{ fontWeight: "bold" }}>{t("Email")}</Typography>
                    <Chip size="small" label={user?.email} variant="outlined" color="primary" />
                </Box>
            </CardContent>
        </Card>
    )
}
